// 外部数据格式
export type StoredRate = {
  rate: 0 | 1 | 2 | 3 | 4 | 5; // 评分，0：表示未选
  name?: string; // rate的中文名称
  description?: string; // rate的中文名称描述
  options?: string[]; // 已选择的选项
  detail?: string; // 用户的详细输入意见
};

export const INIT = { rate: 0 } as StoredRate;

// 内部数据格式
export type RawRate = {
  rate: 1 | 2 | 3 | 4 | 5; // 评分
  name: string; // rate的中文名称
  description: string; // rate的中文名称描述
  options: { name: string; selected: boolean }[]; // 所有的选项
  image?: string; // rate的图标
};

// 显示模式
export type RateShowMode = "only-status" | "all";

export const RATES: StoredRate[] = [
  {
    rate: 1,
    name: "体验很差",
    description: "体验很差，我要吐槽",
    options: [
      "价格偏贵",
      "不该收费",
      "收费体验较差",
      "服务管理不佳",
      "缴费提醒不足",
      "开票不够及时"
    ],
    detail: ""
  },
  {
    rate: 2,
    name: "不太满意",
    description: "不太满意，我要吐槽",
    options: [
      "价格偏贵",
      "不该收费",
      "收费体验较差",
      "服务管理不佳",
      "缴费提醒不足",
      "开票不够及时"
    ],
    detail: ""
  },
  {
    rate: 3,
    name: "一般",
    description: "一般，继续努力",
    options: [
      "体验中规中矩",
      "价格比较一般",
      "流程基本正常",
      "服务还算可以",
      "提醒不够及时",
      "整体体验普通"
    ],
    detail: ""
  },
  {
    rate: 4,
    name: "比较满意",
    description: "比较满意，再接再励",
    options: [
      "缴费便捷高效",
      "计费清晰准确",
      "收费价格合理",
      "服务管理到位",
      "车位环境整洁",
      "整体体验不错"
    ],
    detail: ""
  },
  {
    rate: 5,
    name: "非常满意",
    description: "非常满意，我要点赞",
    options: [
      "缴费便捷高效",
      "计费清晰准确",
      "收费价格合理",
      "服务管理到位",
      "车位环境整洁",
      "整体体验不错"
    ],
    detail: ""
  }
];

// 填充完整数据
export function completeRate(sr?: StoredRate) {
  if (!sr) {
    return sr;
  }
  const sourceRate = RATES.find((r) => r.rate == sr.rate);
  sr.name = sourceRate?.name || sr.name || "";
  sr.description = sourceRate?.description || sr.description || "";
  sr.options = sr.options || [];
  sr.detail = sr.detail || "";
  return sr;
}
